import React from 'react';
import PropTypes from 'prop-types';
import './TitleBar.css';

const TitleBar = props => {
  return (
    <div id="title" className="titleBar">
      <p id="title-text" className="titleText fs-unmask">
        {props.title}
      </p>
    </div>
  );
};

TitleBar.propTypes = {
  title: PropTypes.string.isRequired,
};

export default TitleBar;
